import React from 'react';
import { matchChallengeKeys } from '@repository/match';
import MatchingChallengeVO from '@domain/vo/challenge/MatchingChallengeVO';
import { queryClient } from '@utils/queryClient';
import classnames from 'classnames/bind';
import styles from './challengeDetailBanner.module.scss';

const cx = classnames.bind(styles);

interface ChallengeDetailBannerProps {
  challengeSn: number;
}

const ChallengeDetailBanner = ({ challengeSn }: ChallengeDetailBannerProps) => {
  const data = queryClient.getQueryData<MatchingChallengeVO>([...matchChallengeKeys, challengeSn]);

  if (!data) return null;

  const isCompany = data.type === 'COMPANY';

  return (
    <div className={cx('detailBannerArea')} style={{ backgroundColor: `${data.bannerBackgroundColor}` }}>
      <div className={cx('detailBannerInner')}>
        <div className={cx('textArea')} style={{ color: `${data.bannerTextColor}` }}>
          <strong className={cx('title')}>{data.title}</strong>
          <div className={cx('participationArea')}>
            <span className={cx('mark')} style={{ backgroundColor: `${data.bannerTextColor}` }} />
            {isCompany ? (
              <>
                <span className={cx('participationTitle')}>참여 기업</span>
                {data.participants}
              </>
            ) : (
              <>
                <span className={cx('participationTitle')}>참여 포지션</span>
                {data.participants}
              </>
            )}
          </div>
          <div className={cx('text')}>{data.description}</div>
        </div>
        <div className={cx('imgWrap')} style={{ backgroundImage: `url('${data.bannerImageUrl}')` }} />
      </div>
    </div>
  );
};

export default ChallengeDetailBanner;
